export enum ModalPositionEnum {
  TOP = 'top',
  MIDDEL = 'middle',
  BOTTOM = 'bottom',
}
